import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=652b170d&scoped=true&"
import script from "./WelcomePage.vue?vue&type=script&lang=js&"
export * from "./WelcomePage.vue?vue&type=script&lang=js&"
import style1 from "./WelcomePage.vue?vue&type=style&index=1&id=652b170d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b170d",
  null
  
)

export default component.exports